
export interface LineItemCitationFromJson {
  citation_id: number
  citation_violation: string
  issued_at: string
  balance_due: string
}

class LineItemCitation {
  citationId: number
  violation: string
  issuedAt: string
  balanceDue: string

  constructor (citationId: number, violation: string, issuedAt: string, balanceDue: string) {
    this.citationId = citationId
    this.violation = violation
    this.issuedAt = issuedAt
    this.balanceDue = balanceDue
  }

  static fromJson ({ citation_id, citation_violation, issued_at, balance_due }: LineItemCitationFromJson) {
    return new LineItemCitation(citation_id, citation_violation, issued_at, balance_due)
  }
}

export default LineItemCitation
